export default class Filter {
  constructor(data) {
    this.key = data.key
    this.label = data.label
    this.value = data.value
    this.active = false
  }
}
